// extracted by mini-css-extract-plugin
export default {"subtitleContainer":"style_subtitleContainer__NIvGy","subtitle":"style_subtitle__AYUqO"};